import moment from "moment";
import { Link } from "react-router-dom";
import { splitStringByKeyword } from "../data/essential";
import { editComplaints } from "../roles";
const roles = JSON.parse(localStorage.getItem("roles"));
console.log("roles:", roles)
export const complaintsColumns = (showEditModal,storeRow) => {
    const columns = [
      {
        name: "Id",
        cell: (row) => row.id,
      },
      {
        name: "Account",
        cell: (row) => (
          <Link to={`/loggedin/account/${row?.accountId}`}>
            {row?.accountId}
          </Link>
        ),
      },
      {
        name: "Phone",
        cell: (row) => row?.phoneNumber,
      },
      {
        name: "Type",
        cell: (row) => row?.type?.name,
      },
      {
        name: "Status",
        cell: (row) => row?.status?.name,
      },
      {
        name: "Details",
        cell: (row) => row?.details,
      },
      {
        name: "Info",
        cell: (row) => (
          <div>
            <span style={{ color: "#505050" }}>
              {splitStringByKeyword(row?.info, "By").before}
            </span>
            <span className='ml-1' style={{ color: "#000", fontWeight: 500 }}>
              {splitStringByKeyword(row?.info, "By").after}
            </span>
          </div>
        ),
      },
      {
        name: "Submitted On",
        cell: (row) => moment(row?.datetime).format("DD-MM-YYYY"),
        sortable: true,
        sortFunction: (a, b) => a.datetime.localeCompare(b.datetime),
      },
      {
        name: "Action",
        cell: (row) => (
          <div className='d-flex justify-content-center'>
            {roles.some((role) => role.id === editComplaints) && (
              <i
                className='fa fa-pen'
                style={{ color: "#124db1", cursor: "pointer" }}
                onClick={() => {
                  storeRow(row);
                  showEditModal(true);
                }}
              />
            )}
          </div>
        ),
      },
    ];
  return columns;
}
export const complaintsHeaders = [
  {
    label: "Account Id",
    key: "accountId",
  },
  {
    label: "Phone number",
    key: "phoneNumber",
  },
  {
    label: "Type",
    key: "type",
  },
  {
    label: "Status",
    key: "status",
  },
  {
    label: "Details",
    key: "details",
  },
  {
    label: "Info",
    key: "info",
  },
  {
    label: "Operator",
    key: "operator",
  },
  {
    label: "Date",
    key: "date",
  },
];